import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../api';
import { SignFlow } from '../components/SignFlow';
import { ErrorNote } from '../components/ui';

/** Signing page for people without a PTI account (candidates, contractors): email code, then the same three steps. */
export function PublicSign() {
  const { token } = useParams();
  const [stage, setStage] = useState<'start' | 'code' | 'sign' | 'done'>('start');
  const [sentTo, setSentTo] = useState('');
  const [code, setCode] = useState('');
  const [doc, setDoc] = useState<{ reference: string; title: string; body: string | null; hasFile: boolean; signerName: string } | null>(null);
  const [err, setErr] = useState<unknown>(null);
  const run = async (fn: () => Promise<void>) => { setErr(null); try { await fn(); } catch (e) { setErr(e); } };
  const openFile = () => run(async () => {
    const res = await fetch(`/api/public/sign/${token}/file`);
    if (!res.ok) throw new Error('Could not open the file');
    window.open(URL.createObjectURL(await res.blob()), '_blank', 'noopener');
  });
  return (
    <div className="signin">
      <div className="signin-card wide">
        <div className="brand dark"><span className="mark" aria-hidden="true">P</span><span className="brand-t"><strong>Perth Training Institute</strong><span>RTO 52730 · Secure signing</span></span></div>
        {stage === 'start' && (<>
          <h1>Sign a document</h1>
          <p className="small">To keep this secure we will email you a 6-digit code first.</p>
          <button className="btn primary big" onClick={() => run(async () => { const r = await api.public<{ sentTo: string }>('POST', `/api/public/sign/${token}/code`); setSentTo(r.sentTo); setStage('code'); })}>Email me a code</button>
        </>)}
        {stage === 'code' && (<>
          <h1>Enter your code</h1>
          <p className="small">We sent it to {sentTo}. It expires in 10 minutes.</p>
          <input className="code-input" inputMode="numeric" maxLength={6} aria-label="Code" value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))} />
          <div className="row gap">
            <button className="btn primary" disabled={code.length !== 6} onClick={() => run(async () => { await api.public('POST', `/api/public/sign/${token}/verify`, { code }); setDoc(await api.public('GET', `/api/public/sign/${token}`)); setStage('sign'); })}>Continue</button>
            <button className="link" onClick={() => run(async () => { await api.public('POST', `/api/public/sign/${token}/code`); })}>Send a new code</button>
          </div>
        </>)}
        {stage === 'sign' && doc && (<>
          <h1>{doc.title}</h1><p className="small dim">{doc.reference}</p>
          <SignFlow signerName={doc.signerName} body={doc.body} onOpenFile={openFile}
            onSubmit={async (s) => { await api.public('POST', `/api/public/sign/${token}`, s); }} onCancel={() => setStage('done')} />
        </>)}
        {stage === 'done' && <p>You can close this page.</p>}
        {!!err && <ErrorNote error={err} />}
        <p className="small dim">Questions? Call PTI on 1300 65 05 45.</p>
      </div>
    </div>
  );
}
